module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgment-6"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "manageOrgName",
      "label": "机构名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orgName",
      "align": "center",
      "width": "240",
      "label": "关联机构"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "newAdd",
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('add')
            }
          }
        }, [_vm._v("新增")])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('remove', scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pg-figs"
  }, [(_vm.params.allPage > 1) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.no,
      "page-count": _vm.params.allPage
    },
    on: {
      "current-change": _vm.pageChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgment6_pop",
    attrs: {
      "visible": _vm.diaCtls,
      "width": "600px",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.diaCtls = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-Body clearfix"
  }, [_c('div', {
    staticClass: "bLeft"
  }, [_c('div', {
    staticClass: "ttl"
  }, [_vm._v("\r\n                    自建机构\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "radioCage"
  }, [_c('el-scrollbar', [_c('el-radio-group', {
    model: {
      value: (_vm.ccParams.manageOrganizationId),
      callback: function($$v) {
        _vm.$set(_vm.ccParams, "manageOrganizationId", $$v)
      },
      expression: "ccParams.manageOrganizationId"
    }
  }, _vm._l((_vm.orgArr), function(item) {
    return _c('div', {
      staticClass: "radioItem"
    }, [_c('el-radio', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "midCage"
  }, [_c('i', {
    staticClass: "el-icon-aliziyuan"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bRight"
  }, [_c('div', {
    staticClass: "ttl"
  }, [_vm._v("\r\n                    供应机构\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "checkCage"
  }, [_c('el-scrollbar', [_c('el-checkbox-group', {
    model: {
      value: (_vm.ccParams.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.ccParams, "organizationId", $$v)
      },
      expression: "ccParams.organizationId"
    }
  }, _vm._l((_vm.stationArr), function(item) {
    return _c('div', {
      staticClass: "checkItem"
    }, [_c('el-checkbox', {
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.diaCtls = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.btnTrans('act')
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-1bd2f03e"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/orgConnect.vue
// module id = 1424
// module chunks = 1